import { PersonaType } from '@/modules/shared/schemas/PersonaInfoSummary'
import { adminRouteNames } from '@/ui/routes/routesNames/adminRouteNames'
import { operationalRouteNames } from '@/ui/routes/routesNames/operationalRouteNames'
import { responsibleRouteNames } from '@/ui/routes/routesNames/responsibleRouteNames'
import { therapistRouteNames } from '@/ui/routes/routesNames/therapistRouteNames'

export default function getHomeRoute(personaType?: PersonaType | 'CLINIC') {
  switch (personaType) {
    case 'THERAPIST':
      return therapistRouteNames.home
    case 'CLINIC':
      return adminRouteNames.dashboard
    case 'ADMIN':
      return adminRouteNames.dashboard
    case 'OPERATIONAL':
      return operationalRouteNames.home
    case 'SUPERADMINISTRATOR':
      return '/backoffice/dashboard'
    case 'RESPONSIBLE':
      return responsibleRouteNames.home
    default:
      return '/'
  }
}
